import { mccObjectToArray } from '@/components/trees/mccmnc/utils'

import render from './render'

export default {
  name: 'RulesMccmncValue',

  mixins: [ mccObjectToArray ],

  computed: {
    visibleItems() {
      return this.values.slice(0, this.count)
    },

    overflowCount() {
      return Math.max(this.values.length - this.count, 0)
    },

    shouldShowOverflow() {
      return this.overflowCount > 0
    }
  },

  methods: {
    getLabel({ country, operator, fullCountry }) {
      if (!country) {
        return ''
      }

      if (fullCountry) {
        return country
      }

      return [ country, operator ].join(' | ')
    }
  },

  render
}
